/**
 * Toggle expandable nested bundle child lists in cart page and cart drawer.
 */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.nested-bundle-children-toggle');
  if (!toggle) return;

  event.preventDefault();

  const listId = toggle.getAttribute('aria-controls');
  if (!listId) return;

  const list = document.getElementById(listId);
  if (!list) return;

  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
  const nextExpanded = !isExpanded;

  toggle.setAttribute('aria-expanded', String(nextExpanded));
  list.classList.toggle('nested-bundle-children-list--open', nextExpanded);

  const parentItem = toggle.closest('.cart-product--has-children');
  const bundleParentId = parentItem?.dataset.bundleParentId;

  if (bundleParentId && window.cartDrawer?.expandedBundleParentIds) {
    if (nextExpanded) {
      window.cartDrawer.expandedBundleParentIds.add(bundleParentId);
    } else {
      window.cartDrawer.expandedBundleParentIds.delete(bundleParentId);
    }
  }
});
